import React from "react";

import classNames from "classnames";

import { Typography } from "./clearsense-ui/components";
import ContentBox from "./ContentBox";

const QuickFilter = ({ quickFilterData = [], className }) => (
  <ContentBox
    className={classNames(
      "flex flex-col bg-white dark:bg-[#2f3941] pt-0",
      className
    )}
  >
    <div className="flex justify-center space-x-2 p-2">
      <Typography type="semibold" style="h4">
        Quick Filters
      </Typography>
    </div>
    {quickFilterData.map(({ label, value, onClick }, index) => (
      <div key={index} className="flex w-full space-x-2 p-2" onClick={onClick}>
        <Typography
          style="large"
          className="w-1/2 text-right flex items-center justify-end"
        >
          {label}:
        </Typography>
        <Typography
          style="large"
          className="w-1/2 text-primary-shade hover:underline cursor-pointer"
        >
          {value}
        </Typography>
      </div>
    ))}
  </ContentBox>
);

export default QuickFilter;
